<template>
  <div class="card border-0 rounded-4 shadow-sm">
    <div class="card-body p-3 d-flex flex-column gap-3">

      <!-- Header minimal -->
      <div class="d-flex align-items-start justify-content-between gap-3">
        <div class="d-flex flex-column gap-1">
          <div class="d-flex align-items-center gap-2">
            <span class="badge rounded-pill px-3 py-2 bg-primary-subtle text-primary-emphasis">
              Total: {{ safeTotal.toFixed(1) }}
            </span>
            <span class="badge rounded-pill px-3 py-2" :class="gradeBadge.class">
              Clase {{ grade }}
            </span>
          </div>
          <small class="text-muted">Decisión: <strong>{{ decision }}</strong></small>
        </div>

        <div class="text-end">
          <div class="fw-semibold">Tasa activa</div>
          <div class="fs-5 fw-bold">{{ rate.active }}</div>
          <!-- <small class="text-muted">
            {{ rate.riskFree }} + {{ rate.inflation }} + {{ rate.risk }} + {{ rate.operation }}
          </small> -->
        </div>
      </div>

      <!-- Tabla simple -->
      <div class="table-responsive">
        <table class="table table-sm align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th class="text-muted small">Costo dinero</th>
              <th class="text-muted small">Inflación</th>
              <th class="text-muted small">Riesgo</th>
              <th class="text-muted small">Operación</th>
              <th class="text-muted small text-end">Tasa</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="fw-semibold">{{ rate.riskFree }}</td>
              <td class="fw-semibold">{{ rate.inflation }}</td>
              <td class="fw-semibold">{{ rate.risk }}</td>
              <td class="fw-semibold">{{ rate.operation }}</td>
              <td class="text-end fw-bold">{{ rate.active }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Barra de puntaje (minimal) -->
      <div>
        <div class="d-flex justify-content-between small text-muted mb-1">
          <span>Puntaje</span>
          <span>{{ clampedTotal }} / 100</span>
        </div>
        <div class="progress" style="height: 8px;">
          <div class="progress-bar" :class="gradeBadge.barClass" :style="{ width: clampedTotal + '%' }"></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "SummaryCard",
  props: {
    modelValue: { type: String, default: "" },
    totalScore: { type: Number, default: 0 },
  },
  emits: ["update:modelValue"],
  computed: {
    safeTotal() {
      const n = Number(this.totalScore);
      return Number.isFinite(n) ? n : 0;
    },
    clampedTotal() {
      return Math.max(0, Math.min(100, this.safeTotal));
    },

    grade() {
      const t = this.safeTotal;
      if (t >= 85) return "A";
      if (t >= 70) return "B";
      if (t >= 55) return "C";
      if (t >= 40) return "D";
      return "E";
    },

    decision() {
      switch (this.grade) {
        case "A": return "Aprobar (favorable)";
        case "B": return "Aprobar (estándar)";
        case "C": return "Aprobar (con ajustes)";
        case "D": return "Aprobar (con ajustes)";
        default:  return "Rechazar / Co-deudor";
      }
    },

    rate() {
      const table = {
        A: { riskFree: "6%", inflation: "5%", risk: "4%",  operation: "11%", active: "26%" },
        B: { riskFree: "6%", inflation: "5%", risk: "6%",  operation: "11%", active: "28%" },
        C: { riskFree: "6%", inflation: "5%", risk: "9%",  operation: "11%", active: "31%" },
        D: { riskFree: "6%", inflation: "5%", risk: "12%", operation: "11%", active: "34%" },
        E: { riskFree: "6%", inflation: "5%", risk: "14%", operation: "11%", active: "36%" },
      };
      return table[this.grade];
    },

    gradeBadge() {
      switch (this.grade) {
        case "A":
        case "B":
          return { class: "bg-success-subtle text-success-emphasis", barClass: "" };
        case "C":
        case "D":
          return { class: "bg-warning-subtle text-warning-emphasis", barClass: "" };
        default:
          return { class: "bg-danger-subtle text-danger-emphasis", barClass: "" };
      }
    }
  },
  watch: {
    grade: {
      immediate: true,
      handler(v) {
        this.$emit("update:modelValue", v);
      }
    }
  }
};
</script>

<style scoped>
/* Solo lo mínimo necesario */
.bg-success-subtle { background-color: rgba(25,135,84,.12) !important; }
.text-success-emphasis { color: #146c43 !important; }
.bg-warning-subtle { background-color: rgba(255,193,7,.15) !important; }
.text-warning-emphasis { color: #997404 !important; }
.bg-danger-subtle { background-color: rgba(220,53,69,.12) !important; }
.text-danger-emphasis { color: #842029 !important; }
.bg-primary-subtle { background-color: rgba(13,110,253,.12) !important; }
.text-primary-emphasis { color: #084298 !important; }
</style>
